import LearningEntry from '@/models/LearningEntry';

export default class CourseEntry extends LearningEntry {
	public academicTerm: number | null = null;
	public grade: string | null = null;
}

